import FilterCollapsePanel from './FilterCollapsePanel';

export default FilterCollapsePanel;


// WEBPACK FOOTER //
// ./src/components/FilterCollapsePanel/index.js